import type { Page, PageProps } from '@inertiajs/core';
import { toast } from '@/components/toast';
import type { SharedProps } from '@/types';

// The Next server actions returned `{success, message}` and the caller raised a toast
// with it; here the message is the redirect's flash, which arrives on the page Inertia
// loaded after the mutation. Read it from that page — `usePage()` in the closure still
// holds the pre-mutation props.
export function toastFlash(page: Page<PageProps>, fallback: string) {
  const { flash } = page.props as unknown as SharedProps;

  if (flash.alert) {
    toast({ type: 'error', description: flash.alert });
    return;
  }

  toast({ type: 'success', description: flash.notice ?? fallback });
}
